import React from 'react';

const SocialsIcon = ({ type, className, style }) => {
  if (type === "facebook") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        className,
        style: { ...style, overflow: "visible" },
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M16.6801 15.3598L17.2201 11.9997H14.0401V9.65966C14.0401 8.69964 14.4001 7.97963 15.8401 7.97963H17.4001V4.91957C16.5601 4.79957 15.6001 4.67957 14.7601 4.67957C12.0001 4.67957 10.0801 6.3596 10.0801 9.35965V11.9997H7.08008V15.3598H10.0801V23.8199C10.7401 23.9399 11.4001 23.9999 12.0601 23.9999C12.7201 23.9999 13.3801 23.9399 14.0401 23.8199V15.3598H16.6801Z",
          fill: "#98A7B5"
        }
      )
    );
  }
  if (type === "instagram") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        className,
        style: { ...style, overflow: "visible", transform: "scale(0.5)" },
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none"
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M33.8457 0C41.6605 0 48 6.33953 48 14.1543V33.8457C48 41.6605 41.6605 48 33.8457 48H14.1543C6.33953 48 0 41.6605 0 33.8457V14.1543C0 6.33953 6.33953 0 14.1543 0H33.8457ZM24 12.3076C17.5385 12.3076 12.3076 17.5385 12.3076 24C12.3076 30.4615 17.5385 35.6924 24 35.6924C30.4615 35.6924 35.6924 30.4615 35.6924 24C35.6924 17.5385 30.4615 12.3076 24 12.3076ZM24 16C28.4183 16 32 19.5817 32 24C32 28.4183 28.4183 32 24 32C19.5817 32 16 28.4183 16 24C16 19.5817 19.5817 16 24 16ZM36.9229 8.61523C35.1994 8.61535 33.8457 9.96889 33.8457 11.6924C33.8457 13.4158 35.1994 14.7694 36.9229 14.7695C38.6464 14.7695 40 13.4159 40 11.6924C40 9.96881 38.6464 8.61523 36.9229 8.61523Z",
          fill: "#98A7B5"
        }
      )
    );
  }
  if (type === "discord") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className,
        style: { ...style, overflow: "visible" }
      },
      /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_10153_49646)" }, /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M17.7527 7.85492C16.717 7.46725 15.6096 7.18551 14.4518 7.02509C14.3096 7.23074 14.1435 7.50736 14.029 7.72741C12.7982 7.57933 11.5788 7.57933 10.3707 7.72741C10.2561 7.50736 10.0863 7.23074 9.94279 7.02509C8.78376 7.18551 7.67506 7.46828 6.63935 7.85697C4.55031 10.3824 3.98401 12.8451 4.26716 15.2729C5.65272 16.1006 6.99549 16.6035 8.3156 16.9325C8.64154 16.5736 8.93224 16.1922 9.18267 15.7901C8.70572 15.6451 8.2489 15.4662 7.81727 15.2585C7.93178 15.1906 8.04379 15.1197 8.15201 15.0466C10.7847 16.0317 13.6452 16.0317 16.2464 15.0466C16.3559 15.1197 16.4679 15.1906 16.5811 15.2585C16.1482 15.4672 15.6901 15.6461 15.2132 15.7911C15.4636 16.1922 15.7531 16.5747 16.0803 16.9335C17.4016 16.6045 18.7457 16.1017 20.1312 15.2729C20.4635 12.4585 19.5637 10.0184 17.7527 7.85492ZM9.54134 13.7798C8.75103 13.7798 8.10292 13.1896 8.10292 12.4708C8.10292 11.7521 8.73719 11.1608 9.54134 11.1608C10.3455 11.1608 10.9936 11.751 10.9798 12.4708C10.981 13.1896 10.3455 13.7798 9.54134 13.7798ZM14.857 13.7798C14.0667 13.7798 13.4186 13.1896 13.4186 12.4708C13.4186 11.7521 14.0529 11.1608 14.857 11.1608C15.6612 11.1608 16.3093 11.751 16.2955 12.4708C16.2955 13.1896 15.6612 13.7798 14.857 13.7798Z",
          fill: "#98A7B5"
        }
      )),
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_10153_49646" }, /* @__PURE__ */ React.createElement(
        "rect",
        {
          width: "16",
          height: "12.8",
          fill: "white",
          transform: "translate(4.19922 5.6001)"
        }
      )))
    );
  }
  if (type === "telegram") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className,
        style: { ...style, overflow: "visible" }
      },
      /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_10153_49651)" }, /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M8.12305 12.8783L9.54675 16.8189C9.54675 16.8189 9.72475 17.1876 9.91535 17.1876C10.1059 17.1876 12.9408 14.2384 12.9408 14.2384L16.0933 8.14935L8.17385 11.8611L8.12305 12.8783Z",
          fill: "#C8DAEA"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M10.0088 13.8883L9.73526 16.795C9.73526 16.795 9.62078 17.6856 10.5112 16.795C11.4016 15.9043 12.2539 15.2175 12.2539 15.2175",
          fill: "#A9C6D8"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M8.14724 13.0179L5.21864 12.0637C5.21864 12.0637 4.86864 11.9217 4.98134 11.5997C5.00454 11.5333 5.05134 11.4768 5.19134 11.3797C5.84024 10.9274 17.2019 6.84371 17.2019 6.84371C17.2019 6.84371 17.5227 6.73561 17.7119 6.80751C17.7587 6.822 17.8009 6.84866 17.834 6.88477C17.8671 6.92088 17.89 6.96513 17.9004 7.01301C17.9209 7.09758 17.9294 7.18458 17.9258 7.27151C17.9249 7.34671 17.9158 7.41641 17.9089 7.52571C17.8397 8.64221 15.7689 16.975 15.7689 16.975C15.7689 16.975 15.645 17.4626 15.2011 17.4793C15.0921 17.4828 14.9834 17.4644 14.8816 17.425C14.7798 17.3856 14.687 17.3261 14.6086 17.2501C13.7375 16.5008 10.7267 14.4774 10.0614 14.0324C10.0464 14.0222 10.0338 14.0089 10.0244 13.9933C10.015 13.9778 10.009 13.9604 10.0068 13.9424C9.99754 13.8955 10.0485 13.8374 10.0485 13.8374C10.0485 13.8374 15.2911 9.17741 15.4306 8.68821C15.4414 8.65031 15.4006 8.63161 15.3458 8.64821C14.9976 8.77631 8.96144 12.5882 8.29524 13.0089C8.24729 13.0234 8.1966 13.0265 8.14724 13.0179Z",
          fill: "#98A7B5"
        }
      )),
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_10153_49651" }, /* @__PURE__ */ React.createElement("rect", { width: "24", height: "24", fill: "white" })))
    );
  }
  if (type === "tiktok") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className,
        style: { ...style, overflow: "visible" }
      },
      /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_10153_49657)" }, /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6057 10.5393V9.94327C10.3988 9.91397 10.1902 9.89876 9.98131 9.89777C7.42631 9.89777 5.34766 11.9768 5.34766 14.5318C5.34766 16.0991 6.13096 17.4865 7.32586 18.3254C6.52577 17.4698 6.08096 16.3419 6.08161 15.1705C6.08161 12.6519 8.10111 10.5981 10.6057 10.5393Z",
          fill: "#00F2EA"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.7153 17.2872C11.8553 17.2872 12.7853 16.3804 12.8276 15.2502L12.8315 5.16146H14.6746C14.6352 4.95081 14.6153 4.73699 14.6151 4.52271H12.0979L12.0937 14.6118C12.0517 15.7416 11.1214 16.6481 9.98175 16.6481C9.63961 16.6482 9.30261 16.5649 9 16.4052C9.1954 16.6778 9.45288 16.9 9.75116 17.0534C10.0494 17.2067 10.3799 17.2869 10.7153 17.2872ZM18.1175 8.58586V8.02516C17.4402 8.02578 16.7773 7.82873 16.2104 7.45816C16.7074 8.03051 17.3764 8.4262 18.1175 8.58586Z",
          fill: "#00F2EA"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.2099 7.45677C15.6543 6.82098 15.3482 6.00515 15.3486 5.16077H14.6741C14.7615 5.62747 14.9426 6.0716 15.2066 6.46626C15.4706 6.86091 15.8119 7.19789 16.2099 7.45677ZM9.98133 12.4149C9.42031 12.4155 8.88245 12.6387 8.48574 13.0354C8.08904 13.4321 7.86588 13.9699 7.86523 14.531C7.86561 14.9169 7.97144 15.2954 8.17131 15.6255C8.37117 15.9557 8.65746 16.2249 8.99923 16.4042C8.739 16.0453 8.59886 15.6134 8.59883 15.1701C8.59939 14.609 8.8225 14.071 9.21922 13.6742C9.61593 13.2775 10.1538 13.0543 10.7149 13.0536C10.933 13.0536 11.1419 13.0897 11.3393 13.1516V10.5816C11.1325 10.5523 10.9239 10.5371 10.7149 10.5361C10.6782 10.5361 10.6421 10.5382 10.6057 10.5389V12.5129C10.4038 12.4486 10.1932 12.4155 9.98133 12.4149Z",
          fill: "#FF004F"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.1174 8.58562V10.5421C16.8119 10.5421 15.6026 10.1246 14.6149 9.41582V14.5318C14.6149 17.0868 12.5366 19.1654 9.98162 19.1654C8.99427 19.1654 8.07867 18.8539 7.32617 18.3254C7.75881 18.792 8.28314 19.1641 8.86632 19.4186C9.4495 19.6731 10.0789 19.8043 10.7152 19.8042C13.2702 19.8042 15.3489 17.7255 15.3489 15.1709V10.0549C16.3692 10.7886 17.5946 11.1827 18.8513 11.1812V8.66332C18.5993 8.66332 18.3543 8.63637 18.1174 8.58562Z",
          fill: "#FF004F"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.615 14.5313V9.41532C15.6353 10.1491 16.8607 10.5432 18.1175 10.5416V8.58512C17.3765 8.42531 16.7073 8.02949 16.2103 7.45707C15.8123 7.19819 15.471 6.86122 15.207 6.46656C14.943 6.07191 14.7619 5.62778 14.6745 5.16107H12.8314L12.8276 15.2498C12.7852 16.3796 11.8553 17.2865 10.7153 17.2865C10.3799 17.2861 10.0494 17.206 9.75116 17.0526C9.45289 16.8992 9.1954 16.6771 8.99998 16.4045C8.65814 16.2253 8.37178 15.956 8.17185 15.6259C7.97193 15.2957 7.86604 14.9172 7.86563 14.5313C7.86628 13.9702 8.08943 13.4324 8.48614 13.0357C8.88284 12.639 9.42071 12.4158 9.98173 12.4152C10.1994 12.4152 10.4084 12.4509 10.6061 12.5132V10.5392C8.10153 10.598 6.08203 12.6518 6.08203 15.1704C6.08203 16.3884 6.55523 17.4972 7.32628 18.3253C8.10358 18.8725 9.03114 19.1658 9.98173 19.1649C12.5367 19.1649 14.615 17.0863 14.615 14.5313Z",
          fill: "#98A7B5"
        }
      )),
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_10153_49657" }, /* @__PURE__ */ React.createElement("rect", { width: "24", height: "24", fill: "white" })))
    );
  }
  if (type === "twitter") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className,
        style: { ...style, overflow: "visible" }
      },
      /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_10153_49665)" }, /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M18.1647 9.52895C18.1738 9.6566 18.1738 9.78425 18.1738 9.91307C18.1738 13.8384 15.1012 18.3654 9.48284 18.3654V18.3631C7.82316 18.3654 6.19796 17.9031 4.80078 17.0313C5.04211 17.0595 5.28465 17.0737 5.5278 17.0742C6.9032 17.0754 8.23929 16.6266 9.32135 15.8001C8.01429 15.776 6.86812 14.9472 6.46772 13.7372C6.92558 13.8231 7.39735 13.8054 7.84675 13.686C6.42175 13.406 5.39655 12.1884 5.39655 10.7742V10.7366C5.82114 10.9666 6.29655 11.0942 6.78284 11.1084C5.4407 10.236 5.02699 8.49954 5.83747 7.14189C7.38828 8.99778 9.67639 10.126 12.1326 10.2454C11.8865 9.21366 12.2228 8.13248 13.0163 7.40719C14.2465 6.28248 16.1814 6.34013 17.3379 7.53601C18.022 7.40484 18.6776 7.16072 19.2776 6.81484C19.0496 7.50248 18.5724 8.0866 17.9349 8.45778C18.5403 8.38837 19.1318 8.23072 19.6889 7.99013C19.2788 8.58778 18.7623 9.10837 18.1647 9.52895Z",
          fill: "#98A7B5"
        }
      )),
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_10153_49665" }, /* @__PURE__ */ React.createElement("rect", { width: "24", height: "24", fill: "white" })))
    );
  }
  if (type === "youtube") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className,
        style: { ...style, overflow: "visible" }
      },
      /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_10153_49668)" }, /* @__PURE__ */ React.createElement(
        "mask",
        {
          id: "mask0_10153_49668",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "24",
          height: "24"
        },
        /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#D9D9D9" })
      ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_10153_49668)" }, /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M11.9944 6.59998C11.9944 6.59998 7.11875 6.59998 5.89503 6.91455C5.2398 7.09566 4.70028 7.6294 4.5172 8.28712C4.19923 9.49771 4.19922 12.0047 4.19922 12.0047C4.19922 12.0047 4.19923 14.5213 4.5172 15.7128C4.70028 16.3705 5.23017 16.8948 5.89503 17.0759C7.12838 17.4 11.9944 17.4 11.9944 17.4C11.9944 17.4 16.8797 17.4 18.1034 17.0854C18.7682 16.9043 19.2981 16.3896 19.4716 15.7224C19.7992 14.5213 19.7992 12.0143 19.7992 12.0143C19.7992 12.0143 19.8088 9.49771 19.4716 8.28712C19.2981 7.6294 18.7682 7.1052 18.1034 6.93362C16.8797 6.59999 11.9944 6.59998 11.9944 6.59998ZM10.443 9.68846L14.4997 12.0047L10.443 14.3115V9.68846Z",
          fill: "#98A7B5"
        }
      ))),
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_10153_49668" }, /* @__PURE__ */ React.createElement("rect", { width: "24", height: "24", fill: "white" })))
    );
  }
  if (type === "x") {
    return /* @__PURE__ */ React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "54",
        height: "48",
        viewBox: "0 0 54 48",
        fill: "none",
        className,
        style: { ...style, overflow: "visible", transform: "scale(0.5)" }
      },
      /* @__PURE__ */ React.createElement(
        "path",
        {
          d: "M41.9956 0H50.1432L32.2539 20.369L53.1542 48H36.7528L23.9114 31.2089L9.21033 48H1.06273L20.0148 26.214L0 0H16.8089L28.4103 15.3387L41.9956 0ZM39.1439 43.2177H43.6605L14.4354 4.60517H9.58229L39.1439 43.2177Z",
          fill: "#98A7B5"
        }
      )
    );
  }
  return null;
};
SocialsIcon.displayName = "Icons.SocialsIcon";

export { SocialsIcon };
//# sourceMappingURL=SocialsIcon.js.map
